/**
 * Created with IntelliJ IDEA.
 * User: elanh
 * Date: 6/5/13
 * Time: 1:40 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var $ = require("jquery");
    var _ = require("underscore");
    var Marionette = require("marionette");
    var Logger = require('logger');
    var $draggable = require("jqueryui/draggable");
    var ColorPickerModel = require("ui/color-picker/js/models/ColorPickerModel");
    var template = require('ui/color-picker/templates/colorPicker.tmpl');

    require("ui.plugins/jquery.ba-outside-events");

    var TRANSPARENT = "transparent";

    var ColorPickerView = Marionette.ItemView.extend({
        template : template,
        className : "color-picker",
        events : {
            "click .color-picker-button" : "toggleColorPicker",
            "click .color-map" : "colorMapClicked",
            "click .color-map-eye" : "stopPropagation",
            "click .color-slider" : "colorSliderClicked",
            "click .color-slider-handle" : "stopPropagation",
            "click .color-transparent-btn" : "transparentClicked",
            "change .color-hex input" : "hexInputChanged",
            "change .color-rgb input" : "rgbInputChanged",
            "change .color-hsb input" : "hsbInputChanged",
            "clickoutside":"_handleOutsideClick"
        },
        ui : {
            button : ".color-picker-button",
            picker : ".color-picker-control",
            colorMap : ".color-map",
            colorMapEye : ".color-map-eye",
            colorSlider : ".color-slider",
            colorSliderHandle : ".color-slider-handle",
            colorPreview : ".color-preview",
            hexInput : ".color-hex-input",
            hsbInputH : ".color-hsb-h",
            hsbInputS : ".color-hsb-s",
            hsbInputB : ".color-hsb-b",
            rgbInputR : ".color-rgb-r",
            rgbInputG : ".color-rgb-g",
            rgbInputB : ".color-rgb-b",
            transparentBtn : ".color-transparent-btn"
        },
        modelEvents : {
            "change:Hex" : "handleColorChange",
            "change:isTransparent" : "handleTransparentChange"
        },
        initialize : function (options) {
            //get the color from the $el data-color attr if it's there, otherwise check if it's in the options
            var color = this.$el.data("color") || options.color;
            //pass the color given to the model for parsing and manipulation
            this.model = new ColorPickerModel();
            if (!_.isUndefined(color)) {
                this.setColor(color);
            }
            if (_.has(options,"tooltip")) {
                this.tooltip = options.tooltip;
            }
            this.permutation = options.permutation || ColorPickerView.PERMUTATION.A;

            // members to handle the collision if exist
            this.isRightAligned = false;
            this.isUpwards = false;
            this.collisionWithinSelector = _.has(options, "collisionWithinSelector") ? options.collisionWithinSelector : "window";
            this.testCollision = _.has(options, "testCollision") ? options.testCollision : false;
            this.isLarge =  _.has(options, "large") ? options.large : false;
        },

        onRender : function () {
            this._initDraggable();
            this._renderTransparent(this.model.isTransparent());
            this._renderLarge();
            this._setAllInputs();
            this._setPermutationClass();
            this._setTooltip();
        },
        _setPermutationClass : function(){
            this.$el.addClass(this._getClassByPermutation());
        },
        _getClassByPermutation:function () {
            var cssClass = "color-picker-perm-" + this.permutation;
            return cssClass;
        },
        setColor : function (color) {
            if (color === TRANSPARENT) {
                this.model.setIsTransparent(true);
            } else {
                this.model.setHex(color);
            }
        },
        _setTooltip:function(){
            if(_.isString(this.tooltip)){
                this.ui.button.attr("title", this.tooltip);
            }
        },
        getColor : function () {
            return this.model.getHex();
        },
        handleColorChange : function (model, hexColor) {
            this._setAllInputs();
            //we do not want to trigger color change while dragging the pointer on the color map or the color slider areas
            if (!this.isColorEyeDragged && !this.isColorSliderDragged){
                this.triggerColorChange(hexColor);
            }
        },
        _renderLarge:function(){
            this.ui.button.toggleClass("large", this.isLarge);
        },
        _renderTransparent: function(isTransparent){
            this.ui.button.toggleClass(TRANSPARENT, isTransparent);
            this.ui.colorPreview.toggleClass(TRANSPARENT, isTransparent);
            this.ui.transparentBtn.toggleClass("checked", isTransparent);
        },
        handleTransparentChange : function(model, isTransparent){
            this._renderTransparent(isTransparent);
            if (isTransparent){
                //trigger the change with transparent color
                this.triggerColorChange(TRANSPARENT);
            } else {
                //otherwise, trigger with the hex (it hasn't changed on the model so we need to trigger it manually)
                this.triggerColorChange(model.getHex());
            }
        },
        triggerColorChange : function(color){
            this.trigger("colorPicker:change", color);
        },
        transparentClicked : function () {
            //toggle the transparent state
            this.model.setIsTransparent(!this.model.isTransparent());
        },
        colorMapClicked : function (event) {
            event.stopPropagation();
            var clickYPosition = event.offsetY || event.originalEvent.layerY;// offsetY works in IE & Chrome but doesn't exists in FF (FF offsetY = undefined) so i used layerY (e.layerY is deprecated so i used e.originalEvent.layerY)
            var clickXPosition = event.offsetX || event.originalEvent.layerX;
            var position = {
                top : clickYPosition,
                left : clickXPosition
            };
            var hsb = this._mapPositionToHsb(position, true);
            this.model.setHSB(hsb);
        },
        stopPropagation : function (event) {
            event.stopPropagation();
        },
        colorSliderClicked : function (event) {
            event.stopPropagation();
            var clickYPosition = event.offsetY || event.originalEvent.layerY;// offsetY works in IE & Chrome but doesn't exists in FF (FF offsetY = undefined) so i used layerY (e.layerY is deprecated so i used e.originalEvent.layerY)
            var ui = {
                position : {
                    top : clickYPosition
                }
            };
            var hsb = {
                h : this._calculateHFromSliderPosition(clickYPosition)
            };
            this._handleColorSliderDrag(null, ui);
            this.model.setHSB(hsb, false);
        },
        _handleOutsideClick: function() {
            this.closeColorPicker();
        },

        _initDraggable : function () {
            var that = this;
            this.isColorEyeDragged = false;
            this.ui.colorMapEye.draggable({
                containment : this.ui.colorMap,
                start : function (event, ui) {
                    that.isColorEyeDragged = true;
                },
                drag : _.bind(this._handleColorEyeDrag, this),
                stop : function (event, ui) {
                    that.isColorEyeDragged = false;
                    var hsb = that._mapPositionToHsb(ui.position);
                    that.model.setHSB(hsb, false);
                    //_.bind(that._handleColorEyeDrag, that);
                }
            });
            this.ui.colorMapEye.css("position", "absolute");
            this.isColorSliderDragged = false;
            this.ui.colorSliderHandle.draggable({
                axis : "y",
                containment : this.ui.colorSlider,
                start : function (event, ui) {
                    that.isColorSliderDragged = true;
                },
                drag : _.bind(this._handleColorSliderDrag, this),
                stop : function (event, ui) {
                    that.isColorSliderDragged = false;
                    var top = ui.position.top;
                    var hsb = {
                        h : that._calculateHFromSliderPosition(top)
                    };
                    that.model.setHSB(hsb, false);
                }
            });
            this.ui.colorSliderHandle.css("position", "absolute");
        },
        _calculateHFromSliderPosition: function(topPosition){
            return parseInt(360 - (topPosition * 360 / 141), 10);
        },
        _handleColorEyeDrag : function (event, ui) {
            var hsb = this._mapPositionToHsb(ui.position);
            this.model.setHSB(hsb);
        },
        _handleColorSliderDrag : function (event, ui) {
            var top = ui.position.top;
            //calculate hsb color value from slider position
            var hsb = {
                h : this._calculateHFromSliderPosition(top)
            };
            this.model.setHSB(hsb);
        },
        _setAllInputs : function () {
            //set all the color-picker pieces with the selected color
            this._setColorPickerButton();
            this._setColorMap();
            this._setColorSlider();
            this._setColorPreview();
            this._setColorInputs();
        },
        _setColorPickerButton : function () {
            this.ui.button.css({
                backgroundColor : this.model.getHex()
            });
        },
        _setColorMap : function (hsbInput) {
            var hsb = !_.isUndefined(hsbInput) ? hsbInput : this.model.getHSB();

            //var hsb = this.model.getHSB();
            var hsbForCurrentHue;

            //get coordinates of eye from hsb color value
            var position = this._hsbToMapPosition(hsb);
            if (!this.isColorEyeDragged) {
                this.ui.colorMapEye.stop().animate(position, 100);
            }

            //color-map background is based only on current H (hue) value, while ignoring the current S (saturation) and B (Brightness).
            hsbForCurrentHue = {
                h: hsb.h,
                s: 100,
                b: 100
            };
            this.ui.colorMap.css({
                backgroundColor : this.model.HSBToHex(hsbForCurrentHue)
            });
        },

        _getColorMapEyeRadius: function() {
//            if (!this._colorMapEyeRadius) {
//                this._colorMapEyeRadius = this.ui.colorMapEye.width() / 2;
//            }
//            return this._colorMapEyeRadius;

            // This method can be called before the view has been rendered so the above code return zero - no other choice than returning hard code value.
            return 6;
        },

        _getColorMapDimensionLength : function () {
//            if (!this._colorMapDimensionLength) {
//                this._colorMapDimensionLength = this.ui.colorMap.width();
//            }
//            return this._colorMapDimensionLength;

            // This method can be called before the view has been rendered so the above code return zero - no other choice than returning hard code value.
            return 150;
        },

        /**
         * Gets cursor position (left, top) on map and returns appropriate hsb value.
         * Notice that cursor position only changes S and B values, H value remains the same.
         * @param isClick true for mouse click, false for mouse drag - there is a different between drag and click: drag position is the top left corner of the eye, click position is the center of the eye.
         */
        _mapPositionToHsb: function(position, isClick) {
            var l = this._getColorMapDimensionLength(),
                r = this._getColorMapEyeRadius(),
                x = position.left,
                y = position.top;

            if (isClick) {
                x -= r;
                y -= r;
            }

            // Handle cases that cursor position is in the map shoulders - fix the position (can happen on click, or even on drag in case user has changed zoom level)
            if (x > l - 2*r) {
                x = l - 2*r;
            }
            if (x < 0) {
                x = 0;
            }
            if (y > l - 2*r) {
                y = l - 2*r;
            }
            if (y < 0) {
                y = 0;
            }

            return {
                h: parseInt(this.ui.hsbInputH.val(), 10), // Keeping the H as current input field value for H
                s: x/(l - 2*r)*100,
                b: 100 - y/(l - 2*r)*100
            };
        },

        /**
         * Takes S and B values from hsb and returns cursor position (left, top)
         * @param hsb
         */
        _hsbToMapPosition: function(hsb) {
            var l = this._getColorMapDimensionLength(),
                r = this._getColorMapEyeRadius();

            return {
                left: hsb.s/100*(l - 2*r),
                top: (100-hsb.b)/100*(l - 2*r)
            };
        },

        _setColorSlider : function (hsbInput) {
            var hsb = !_.isUndefined(hsbInput) ? hsbInput : this.model.getHSB();
            var top = parseInt(141 - hsb.h * 141 / 360, 10);
            if (!this.isColorSliderDragged) {
                this.ui.colorSliderHandle.stop().animate({
                    top : top
                }, 100);
            }
        },
        _setColorPreview : function () {
            this.ui.colorPreview.css({
                backgroundColor : this.model.getHex()
            });
        },
        _setColorInputs : function () {
            //remove the "#" character
            var hexColor = this.model.getHex().substring(1);
            var hsbColor = this.model.getHSB();
            var rgbColor = this.model.getRGB();
            this.ui.hexInput.val(hexColor);
            this.ui.hsbInputH.val(hsbColor.h);
            this.ui.hsbInputS.val(hsbColor.s);
            this.ui.hsbInputB.val(hsbColor.b);
            this.ui.rgbInputR.val(rgbColor.r);
            this.ui.rgbInputG.val(rgbColor.g);
            this.ui.rgbInputB.val(rgbColor.b);
        },

        hexInputChanged : function () {
            var hex = "#"+this.ui.hexInput.val();
            this.model.setHex(hex);
        },
        rgbInputChanged : function () {
            var rgb = {
                r : parseInt(this.ui.rgbInputR.val(), 10),
                g : parseInt(this.ui.rgbInputG.val(), 10),
                b : parseInt(this.ui.rgbInputB.val(), 10)
            };
            this.model.setRGB(rgb);
        },
        hsbInputChanged : function () {
            var hsb = {
                h : parseInt(this.ui.hsbInputH.val(), 10),
                s : parseInt(this.ui.hsbInputS.val(), 10),
                b : parseInt(this.ui.hsbInputB.val(), 10)
            };
            this.model.setHSB(hsb);
        },

        openColorPicker : function () {
            if (this.testCollision) {
                this._handlePickerCollisionWithBoundaries();
            }
            this.ui.picker.show();
        },
        closeColorPicker : function () {
            this.ui.picker.hide();
        },
        toggleColorPicker : function () {
            if (this.ui.picker.is(":visible")) {
                this.closeColorPicker();
            } else {
                this.openColorPicker();
            }
        },
        _handlePickerCollisionWithBoundaries: function() {
            this._handlePickerCollisionWithRightBoundary();
            this._handlePickerCollisionWithBottomBoundary();
        },
        _handlePickerCollisionWithRightBoundary: function() {
            this.ui.picker.addClass("special-hide-for-width-calculation"); // we are using display:block and visibility:hidden for calculate the width of element that is hidden
            var buttonOffsetX = this.ui.button.offset().left;
            var pickerWidth = this.ui.picker.outerWidth(true);  // calculate the width includes the border, padding and margin. the "true" is for calculating also the margin
            this.ui.picker.removeClass("special-hide-for-width-calculation");

            var pickerRightX = buttonOffsetX + pickerWidth;

            // If collisionWithinSelector is not window, use minimum of window and collisionWithinSelector right X value
            var boundaryRightX = this.collisionWithinSelector === "window" ? window.innerWidth :
                _.min([$(this.collisionWithinSelector).offset().left + $(this.collisionWithinSelector).width(), window.innerWidth]);

            this.isRightAligned = pickerRightX > boundaryRightX;
            this.ui.picker.toggleClass("picker-right-aligned", this.isRightAligned);
        },
        _handlePickerCollisionWithBottomBoundary: function() {
            this.ui.picker.addClass("special-hide-for-width-calculation"); // we are using display:block and visibility:hidden for calculate the width of element that is hidden
            var buttonOffsetY = this.ui.button.offset().top;
            var buttonHeight = this.ui.button.outerHeight(true);
            var pickerHeight = this.ui.picker.outerHeight(true);  // calculate the width includes the border, padding and margin. the "true" is for calculating also the margin
            this.ui.picker.removeClass("special-hide-for-width-calculation");

            var pickerBottomY = buttonOffsetY + buttonHeight + pickerHeight;

            // If collisionWithinSelector is not window, use minimum of window and collisionWithinSelector right X value
            var boundaryBottomY = this.collisionWithinSelector === "window" ? window.innerHeight :
                _.min([$(this.collisionWithinSelector).offset().top + $(this.collisionWithinSelector).height(), window.innerHeight]);

            this.isUpwards = pickerBottomY > boundaryBottomY;
            this.ui.picker.toggleClass("picker-upwards", this.isUpwards);
        },
        onClose : function () {
            this.model = null;
        }
    });

    /**
     * Public static eNum of the optional permutation
     */
    ColorPickerView.PERMUTATION = {
        A   :1, //color
        B   :2, //border
        C   :3, //color no transparent
        D   :4, //border no transparent
        E   :5  //text button
    };

    ColorPickerView.TYPE = {
        CLR :1,
        BO  :2,//border
        BG  :3 //bsckground
    };
    return ColorPickerView;
});
